
















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import * as Helper from '@/helpers'

@Component
export default class RenderCargaDanfe extends Vue {
  @Prop({required: true}) danfe!: string

  copyToClipboard() {
    Helper.copyToClipboard(this.danfe)
    Helper.info('system.info.copiedToClipboard')
  }
}
